export default __webpack_public_path__ + "9b2cb1eaad51510ac6c7ddc357864719.png";